var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tier-badge d-inline-block py-0 px-2 text-center rounded"},[_c('span',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.$t(`serviceTier.${_vm.tierName}`)))])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }